import { Reducer } from "redux";

import { IOrderBy, OrderType } from "@multiweb/types/multiweb";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    IInitDataSourceAction,
    ISetOrderByAction,
    IToggleOrderByAction,
} from "../types";

export const orderByReducer: Reducer<ReadonlyArray<IOrderBy>> = (
    state = DATA_SOURCE_INIT_STATE.orderBy,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        if (action.payload.orderBy !== undefined) {
            return action.payload.orderBy.map((orderBy) => ({
                ...orderBy,
                attributeName: orderBy.attributeName.toLowerCase(),
            }));
        }
    } else if (action instanceof ISetOrderByAction) {
        return [...action.payload.orderBy];
    } else if (action instanceof IToggleOrderByAction) {
        const {
            payload: { attributeName, clearOthers },
        } = action;

        const newOrderBy = state.filter(
            (orderBy) => !clearOthers || orderBy.attributeName === attributeName,
        );
        const orderByIndex = newOrderBy.findIndex((orderedBy) => orderedBy.attributeName === attributeName);
        if (orderByIndex === -1) {
            // attributeName nenalezen -> vložím na konec
            return newOrderBy.concat([{ attributeName, order: OrderType.ascending }]);
        } else if (state[orderByIndex].order === OrderType.ascending) {
            // ascending -> descending
            newOrderBy[orderByIndex].order = OrderType.descending;
            return newOrderBy;
        } else {
            // descending -> odstranit
            newOrderBy.splice(orderByIndex, 1);
            return newOrderBy;
        }
    }
    return state;
};
